module.exports = __webpack_public_path__ + "img/5.d1d9d9cf.png";